import {
    AppSku,
    RiderColor,
    VehicleType,
} from '@polaris-customerweb/sharedcomponents.core';
import {
    Geofence,
    PlannedRide,
    TrackedRide,
    Waypoint,
} from '@polaris-customerweb/sharedcomponents.user-content';

export type GeoFileImportRideType = 'OffRoad' | 'Snow' | 'Both';

export class GeoFileImport {
    sessionId: string;
    name: string;
    description?: string;
    isCollection?: boolean;
    items: GeoFileImportItem[];
}

export class GeoFileImportItem {
    index: number;
    name?: string;
    color?: RiderColor;
    type?: string;
    displayMapType?: GeoFileImportRideType;
    rideType: VehicleType;

    static fromItem(
        item: PlannedRide | TrackedRide | Waypoint | Geofence,
        displayMapType: GeoFileImportRideType,
        rideType: AppSku,
        index = 0
    ): GeoFileImportItem {
        return {
            color: item.color,
            displayMapType,
            index,
            name: item.name,
            rideType,
            type: item.type,
        };
    }
}
